import React from 'react'

const Settings = ({ width = '15px', height = '15px', ...props }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 15 15"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <title>icons / location</title>
    <g
      id="2.-Onde-usar"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="4.1-Onde-Usar-(Mobile)-Modo-lista-(mobile)"
        transform="translate(-295.000000, -179.000000)"
        fill="#24206B"
        fillRule="nonzero"
      >
        <g id="Group-5" transform="translate(287.000000, 170.000000)">
          <g id="icons-/-location" transform="translate(8.800000, 9.600000)">
            <path
              d="M12.3431482,0.457757297 C12.8526533,0.216412765 13.3835872,0.747346684 13.1422427,1.25685181 L13.1422427,1.25685181 L7.7422427,12.6568518 C7.50106535,13.166004 6.75455539,13.0920849 6.6179145,12.5455214 L6.6179145,12.5455214 L5.505,8.0944 L1.05447862,6.9820855 C0.531678695,6.85138552 0.441317221,6.16269569 0.880034605,5.89198933 L0.880034605,5.89198933 L0.943148193,5.8577573 Z M11.3382,2.2612 L2.9718,6.2242 L6.14552138,7.0179145 C6.33660683,7.06568586 6.49046093,7.20361618 6.56003693,7.38465869 L6.56003693,7.38465869 L6.5820855,7.45447862 L7.3752,10.6276 L11.3382,2.2612 Z"
              id="Path"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export default Settings
